module.exports = __webpack_public_path__ + "static/img/yinliangjian.d638de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/yinliangjian.png
// module id = 7z37
// module chunks = 24